import { ICounterparties, ICounterpartiesListItem } from '@/entity/finance/counterparties/counterparties.types'
import { CounterpartiesStore } from '@/store/modules/Counterparties'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class CounterpartiesMix extends Vue {
    get counterpartiesloaded(): boolean {
        return CounterpartiesStore.counterpartiesLoaded
    }
    get counterparty(): ICounterpartiesListItem | null {
        return CounterpartiesStore.counterparty
    }
    get counterparties(): ICounterparties | null {
        return CounterpartiesStore.counterparties
    }
}